import Skeleton from '@/components/Skeleton/Skeleton.vue'

export default {
  components: {
    Skeleton
  },
  props: [
    'totalStakedInCgu',
    'totalStakedInUsdt',
    'stakedUsd',
    'totalStakedInUsdtFormatted',
    'totalStakedInCguFormatted',
    'poolRewardApy',
    'stakers',
    'totalRewardsInCgu',
    'totalRewardsInUsd'
  ],
  data () {
    return {
      style: { width: 700 },
    }
  },
}
